module.exports = __webpack_public_path__ + "add04383bc49087c6846afa69c61a329.svg";